module.exports = __webpack_public_path__ + "img/notification.de128291.svg";